import { useMemo } from 'react';
import { SettingsPageInputs, SettingsPageConfig } from 'src/auth/settings/types';
import { isSsoOnly } from 'src/auth/utils/ory-helpers';

export const useSettingsPageConfig = ({
  source,
  authMethod,
  oidcNodes,
  hasPasswordSet,
}: SettingsPageInputs): SettingsPageConfig => {
  return useMemo(() => {
    const isRecoveryFlow = source === 'recovery';
    const ssoOnly = isSsoOnly(authMethod);
    const hasOidcNodes = oidcNodes.length > 0;

    const showSsoOnlyMessage = ssoOnly;

    const pageTitle = isRecoveryFlow ? 'Reset your password' : 'Manage Credentials';

    const showPasswordSection = !ssoOnly;

    let passwordSectionSubtitle: string | null = null;
    if (!isRecoveryFlow && showPasswordSection) {
      passwordSectionSubtitle = hasPasswordSet ? 'Change your password' : 'Set a password';
    }

    const passwordInputLabel = hasPasswordSet ? 'New password' : 'Password';

    const passwordInputPlaceholder = hasPasswordSet ? 'Enter new password' : 'Create a password';

    let submitButtonText: string;
    if (isRecoveryFlow) {
      submitButtonText = 'Reset password';
    } else if (hasPasswordSet) {
      submitButtonText = 'Update password';
    } else {
      submitButtonText = 'Set password';
    }

    const showSsoSection = hasOidcNodes && !ssoOnly;

    const showDivider = showPasswordSection && showSsoSection;

    const ssoSectionSubtitle = ssoOnly ? 'Sign in with your organization' : 'Linked accounts';

    return {
      pageTitle,
      showPasswordSection,
      passwordSectionSubtitle,
      passwordInputLabel,
      passwordInputPlaceholder,
      submitButtonText,
      showDivider,
      showSsoSection,
      ssoSectionSubtitle,
      showSsoOnlyMessage,
    };
  }, [source, authMethod, oidcNodes, hasPasswordSet]);
};
